import { render, staticRenderFns } from "./educationUser.vue?vue&type=template&id=f3bcf908"
import script from "./educationUser.vue?vue&type=script&lang=js"
export * from "./educationUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3bcf908')) {
      api.createRecord('f3bcf908', component.options)
    } else {
      api.reload('f3bcf908', component.options)
    }
    module.hot.accept("./educationUser.vue?vue&type=template&id=f3bcf908", function () {
      api.rerender('f3bcf908', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/cc/educationUser.vue"
export default component.exports